export const getRedirectURL = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get('redirect');
};

export const getPoolId = () => {
    if (!window.HiveSSOPoolId.match(/^%%(.*)%%$/)) {
        return window.HiveSSOPoolId;
    }
};

export const getCognitoClientId = () => {
    if (!window.HiveSSOCognitoClientId.match(/^%%(.*)%%$/)) {
        return window.HiveSSOCognitoClientId;
    }
};

export const getPublicCognitoClientId = () => {
    if (!window.HiveSSOPublicCognitoClientId.match(/^%%(.*)%%$/)) {
        return window.HiveSSOPublicCognitoClientId;
    }
};

export const getClientId = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get('client');
};

export const getState = () => {
    if (!window.HiveSSOState.match(/^%%(.*)%%$/)) {
        return window.HiveSSOState;
    }
};

export const getOAuthRedirectUri = () => {
    if (!window.HiveOAuthRedirectUri.match(/^%%(.*)%%$/)) {
        return window.HiveOAuthRedirectUri;
    }
};

export const getScope = () => {
    if (!window.HiveScope.match(/^%%(.*)%%$/)) {
        return window.HiveScope;
    }
};

export const getResponseType = () => {
    if (!window.HiveResponseType.match(/^%%(.*)%%$/)) {
        return window.HiveResponseType;
    }
};
